<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="550" overlay-opacity="0.9" overlay-color="black">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" v-on="on" class="d-flex align-center cursor-pointer hover-effect">
          <v-icon x-small color="grey" class="mr-1">mdi-information-outline</v-icon>
          <span class="text-caption grey--text" style="text-decoration: underline">Regelung</span>
        </div>
      </template>

      <v-card class="rounded-xl glass-card" color="#1E1E1E" elevation="0">
        <v-sheet color="transparent" class="px-6 pt-6 pb-2">
          <div class="d-flex align-center mb-2">
            <v-sheet color="rgba(255, 152, 0, 0.15)" class="rounded-circle pa-3 mr-4">
              <v-icon color="orange" large>mdi-coffee-outline</v-icon>
            </v-sheet>
            <div>
              <div class="text-caption orange--text font-weight-bold letter-spacing-1 text-uppercase">Wichtig zu wissen</div>
              <div class="text-h5 font-weight-bold white--text">Pausenregelung Schweiz</div>
            </div>
          </div>
        </v-sheet>

        <v-divider class="border-light mx-6"></v-divider>

        <v-card-text class="px-6 py-6">
          <div class="rounded-lg overflow-hidden border-light" style="background: rgba(0, 0, 0, 0.2)">
            <v-row no-gutters class="pa-3 grey darken-4">
              <v-col cols="7" class="text-caption font-weight-bold grey--text text--uppercase">Arbeitszeit (Täglich)</v-col>
              <v-col cols="5" class="text-caption font-weight-bold grey--text text--uppercase text-right">Pause (Min)</v-col>
            </v-row>
            <v-divider class="border-light"></v-divider>

            <v-row no-gutters class="pa-4 align-center rule-row">
              <v-col cols="7" class="white--text font-weight-medium">bis zu 5.5 Stunden</v-col>
              <v-col cols="5" class="text-right grey--text">-</v-col>
            </v-row>
            <v-divider class="border-light mx-2"></v-divider>
            <v-row no-gutters class="pa-4 align-center rule-row">
              <v-col cols="7" class="white--text font-weight-medium">5.5 bis 7 Stunden</v-col>
              <v-col cols="5" class="text-right orange--text font-weight-bold">15 Min</v-col>
            </v-row>
            <v-divider class="border-light mx-2"></v-divider>
            <v-row no-gutters class="pa-4 align-center rule-row">
              <v-col cols="7" class="white--text font-weight-medium">7 bis 9 Stunden</v-col>
              <v-col cols="5" class="text-right orange--text font-weight-bold">30 Min</v-col>
            </v-row>
            <v-divider class="border-light mx-2"></v-divider>
            <v-row no-gutters class="pa-4 align-center rule-row">
              <v-col cols="7" class="white--text font-weight-medium">mehr als 9 Stunden</v-col>
              <v-col cols="5" class="text-right orange--text font-weight-bold">60 Min</v-col>
            </v-row>
          </div>

          <div class="mt-4 d-flex align-start">
            <v-icon small color="grey" class="mt-1 mr-2">mdi-information</v-icon>
            <span class="text-caption grey--text">
              Pausen > 30 Min dürfen aufgeteilt werden. Die Mittagspause muss jedoch mind. 30 Minuten am Stück betragen.
            </span>
          </div>
        </v-card-text>

        <v-card-actions class="px-6 pb-6 pt-0">
          <v-btn block large color="orange" depressed class="rounded-lg white--text font-weight-bold shadow-orange" @click="dialog = false">
            Alles klar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "BreakRules",
  data() {
    return {
      dialog: false,
    }
  },
}
</script>

<style scoped>
.glass-card {
  background: rgba(30, 30, 30, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
}
.border-light {
  border-color: rgba(255, 255, 255, 0.08) !important;
}
.rule-row:hover {
  background: rgba(255, 255, 255, 0.03);
}
.cursor-pointer {
  cursor: pointer;
}
.hover-effect:hover .text-caption {
  color: white !important;
}
.shadow-orange {
  box-shadow: 0 4px 15px rgba(255, 152, 0, 0.3);
}
.letter-spacing-1 {
  letter-spacing: 1px;
}
</style>
